import type { ReactNode } from 'react'
import { Typography, Button, Box, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Warning } from '@dhl/icons'

type Props = {
  barcode: string
  children: ReactNode
  onClose: () => void
}

export const BarcodeScannerErrorMessage = ({ barcode, children, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <Grid
      container
      wrap="nowrap"
      justifyContent="space-around"
      alignItems="center"
      direction="column"
      sx={{
        backgroundColor: 'error.main',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'fixed',
        zIndex: 1400,
      }}
    >
      <Grid>
        <Warning
          color="primary"
          sx={{
            color: 'grey.100',
            fontSize: 140,
          }}
        />
      </Grid>
      <Grid>
        <Grid container wrap="nowrap" direction="column" alignItems="center" spacing={2} color="grey.100">
          <Grid>
            <Box mx={2}>
              <Typography variant="subtitle2" align="center" data-test="barcode-error">
                {children}
              </Typography>
            </Box>
          </Grid>
          {barcode && (
            <Grid>
              <Typography variant="body2">{t('components.inputs.barcodeInput.barcode', { barcode })}</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid flexWrap="nowrap" pb="48px">
        <Button
          aria-label="back"
          onClick={onClose}
          fullWidth
          variant="contained"
          data-test="close-error-message-button"
          sx={{
            backgroundColor: 'grey.100',
            color: 'primary.main',
          }}
        >
          {t('components.inputs.barcodeInput.backToScanner')}
        </Button>
      </Grid>
    </Grid>
  )
}
